import { render } from "./ModeloEdicao.vue?vue&type=template&id=3c2ea549&scoped=true&ts=true"
import script from "./ModeloEdicao.vue?vue&type=script&lang=ts"
export * from "./ModeloEdicao.vue?vue&type=script&lang=ts"

import "./ModeloEdicao.vue?vue&type=style&index=0&id=3c2ea549&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2ea549"]])

export default __exports__